<div class="spinnerbackground" *ngIf="showSpinner" style="text-align: center;">

    <div class="lds-facebook"><div></div><div></div><div></div></div>

</div>


